<script>
  import { createEventDispatcher } from 'svelte';

  import Value from './value.svelte';
  import Clicker from './clicker.svelte';

  export let layout;
  export let values;
  export let extras = undefined;

  const checkExpression = (content, vals) => new Function('content, value', content.expression)(content, vals);

  const traverseObject = (obj, path) => {
    if (Array.isArray(obj) && path[0].startsWith('[')) {
      const [key, prop] = path[0].split('.');
      const [field, value] = key.substring(1, key.length-1).split(':');
      obj = obj.find(i => i[field] === value);
      if (path.length === 1) {
        path = prop.includes('/') ? prop.split('/') : [prop]
      } else {
        path = [...(prop.includes('/') ? prop.split('/') : [prop]), path.slice(1)];
      }
    }
    obj = obj[path[0]];
    path = path.splice(1);

    if (path.length) {
      obj = traverseObject(obj, path);
    }
    return obj;
  }

  const dispatch = createEventDispatcher();
</script>

<svelte:element this={ layout.tag || 'div' } id={ layout.id } class={ layout.class }>
  {#each layout.contents as content}
    {#if !content.expression || checkExpression(content, values)}
      {#if content.type === 'group'}
        <svelte:self layout={ content } { extras } bind:values={ values } on:message={ ({ detail }) => { dispatch('message', detail) } } />
      {:else if content.type === 'clicker'}
        <Clicker tag={ content.tag } content={ content.content } message={ content.message } on:message={ ({ detail }) => { dispatch('message', detail) } } />
      {:else if content.type === 'value'}
        <Value layout={ content } value={ content.key.includes('/') ? traverseObject(values, content.key.split('/'), content.schema) : values[content.key] } />
      {:else}
        <svelte:component this={ extras.components[content.type] } layout={ content } { extras } bind:values={ values } on:message={ ({ detail }) => { dispatch('message', detail) } } />
      {/if}
    {/if}
  {/each}
</svelte:element>